<template>
  <v-container fluid v-if="tiene_empresa">
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Usuarios</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                label="Buscar"
                outlined
                dense
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="nuevoUsuario()"> Nuevo </v-btn>
            </v-toolbar>
          </template>

          <template v-slot:[`item.editar`]="{ item }">
            <v-icon class="mr-2" @click="editarUsuario(item)">
              fa-solid fa-pen-to-square
            </v-icon>
          </template>

          <template v-slot:[`item.action_emp`]="{ item }">
            <v-icon class="mr-2" @click="listarEmpresasXusuario(item)">
              fa-solid fa-handshake
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_usuario" width="500" persistent>
      <v-card>
        <v-card-text class="pa-0">
          <v-tabs>
            <v-tab> Usuario </v-tab>
            <v-tab v-if="code == 0"> Empresas </v-tab>
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-form ref="form">
                    <v-row>
                      <v-col cols="9">
                        <v-text-field
                          v-model="nombre"
                          label="Nombre"
                          outlined
                          dense
                          hide-details
                          :rules="requerido_rule"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-checkbox
                          v-model="activo"
                          label="Activo"
                          hide-details
                          class="my-auto"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          v-model="correo"
                          label="Correo"
                          outlined
                          hide-details
                          dense
                          :rules="email_rules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-autocomplete
                          v-model="id_rol"
                          :items="items_roles"
                          item-text="nombre"
                          item-value="id_rol"
                          label="Rol"
                          outlined
                          dense
                          hide-details
                          :rules="requerido_rule"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="contraseña"
                          label="Contraseña"
                          outlined
                          dense
                          hide-details
                          type="password"
                          :rules="requerido_rule"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-row>
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="id_sucursal"
                        :items="items_sucursales"
                        item-text="nombre"
                        item-value="id_sucursal"
                        label="Sucursal"
                        outlined
                        dense
                        hide-details
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="id_punto_venta"
                        :items="items_punto_venta"
                        item-text="descripcion"
                        item-value="id_punto_venta"
                        label="Punto de venta"
                        outlined
                        dense
                        hide-details
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-card-text class="pa-0">
                  <v-card elevation="0">
                    <v-card-text>
                      <v-data-table
                        v-model="select_emp"
                        :headers="headers_emp"
                        :items="items_emp"
                        show-select
                        item-key="id_empresa"
                        @item-selected="estatuSeleccionado"
                        :search="search_emp"
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title>Empresas</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field
                              v-model="search_emp"
                              label="Buscar"
                              outlined
                              dense
                              hide-details
                            ></v-text-field>
                          </v-toolbar>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="crearUsuario()" v-if="code == 0"
            >Guardar</v-btn
          >
          <v-btn color="primary" @click="actualizarUsuario()" v-if="code == 1"
            >Actualizar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialogNuevoUsuario()"> Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_empresas" width="600">
      <v-card>
        <v-card-text>
          <v-data-table
            v-model="select_emp"
            :headers="headers_emp"
            :items="items_emp"
            show-select
            item-key="id_empresa"
            @item-selected="estatuSeleccionado"
            :search="search_emp"
            dense
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Empresas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search_emp"
                  label="Buscar"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-toolbar>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" @click="aplicarCambios(id_usuario)"
            >Aplicar cambios</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cancelarEmp()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      timeout="7000"
      top
      right
      outlined
      color="primary"
    >
      <v-icon color="yellow">fa-solid fa-circle-info</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    search: "",
    search_emp: "",
    headers: [
      { text: "Nombre", value: "nombre", sortable: false },
      { text: "Correo", value: "correo", sortable: false },
      { text: "Editar", value: "editar", sortable: false, align: "center" },
      {
        text: "Empresas",
        value: "action_emp",
        sortable: false,
        align: "center",
      },
    ],
    items: [],
    code: 0,
    snackbar: false,
    snackbar_text: "Texto",
    email_rules: [
      (v) => !!v || "Correo es requerido",
      (v) => /.+@.+\..+/.test(v) || "Correo no es valido",
    ],
    requerido_rule: [(v) => !!v || "Correo es requerido"],
    //USUARIO
    dialog_usuario: false,
    id_usuario: 0,
    nombre: "",
    correo: "",
    contraseña: "",
    act_contraseña: "",
    activo: true,
    //ROL
    id_rol: 0,
    items_roles: [],
    //EMPRESAS
    dialog_empresas: false,
    headers_emp: [{ text: "Nombre", value: "nombre_empresa" }],
    items_emp: [],
    select_emp: [],
    unselect_emp: [],
    loading: false,
    id_sucursal: "",
    items_sucursales: [],
    id_punto_venta: "",
    items_punto_venta: [],
  }),
  created() {
    //console.log(this.$store.state.usuario);
  },
  computed: {
    tiene_empresa() {
      if (this.$store.state.emp) {
        this.listarUsuariosPorEmpresa();
        this.listarRoles();
        this.listarEmpresas();
        this.listarSucursales();
        this.listarPuntosVenta();
        return true;
      }
    },
  },
  methods: {
    listarUsuariosPorEmpresa() {
      if (this.$store.state.emp.id_empresa != undefined) {
        this.loading = true;
        axios
          .get(
            "api/UsuariosXEmpresas/ListarXEmpresa/" +
              this.$store.state.emp.id_empresa
          )
          .then((response) => {
            //console.log(response.data);
            this.items = response.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    listarRoles() {
      axios.get("api/Roles/Listar").then((response) => {
        this.items_roles = response.data;
      });
    },
    listarEmpresas() {
      this.loading = true;
      if (this.$store.state.usuario.rol == "IT") {
        axios
          .get("api/DetallesEmpresas/Listar")
          .then((response) => {
            //console.log(response.data);
            this.items_emp = response.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        axios
          .get("api/DetallesEmpresas/BusquedaEmpresa")
          .then((response) => {
            //console.log(response.data);
            this.items_emp = response.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    listarEmpresasXusuario(item) {
      //console.log(item);
      this.loading = true;
      this.id_usuario = item.id_usuario;
      axios
        .get("api/UsuariosXEmpresas/ListarXid/" + item.id_usuario)
        .then((response) => {
          //console.log(response.data);
          this.loading = false;
          this.select_emp = response.data;
          this.dialog_empresas = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    nuevoUsuario() {
      this.dialog_usuario = true;
      this.code = 0;
    },
    crearUsuario() {
      var list_emp = [];
      for (var i = 0; i < this.select_emp.length; i++) {
        list_emp.push(this.select_emp[i].id_empresa);
      }

      if (this.select_emp.length == 0) {
        this.snackbar_text = "Debe de seleccionar una empresa";
        this.snackbar = true;
        return;
      }
      axios
        .post("api/Usuarios/Crear", {
          nombre: this.nombre,
          id_rol: this.id_rol,
          correo: this.correo,
          password: this.contraseña,
          id_usuario: this.id_usuario,
          id_sucursal: this.id_sucursal,
          id_punto_venta: this.id_punto_venta,
          activo: this.activo,
          lista_empresas: list_emp,
        })
        .then((response) => {
          if (response.data == -1) {
            this.snackbar_text = "El correo ya esta creado";
            this.snackbar = true;
            return;
          }
          if (response.data == 0) {
            this.snackbar_text = "No se pudo crear el usuario";
            this.snackbar = true;
            return;
          }

          this.dialog_usuario = false;
          this.aplicarCambios(response.data);
        })
        .catch(() => {
          this.snackbar_text = "Sucedio algún error";
          this.snackbar = true;
        });
    },
    editarUsuario(item) {
      //console.log(item);
      this.code = 1;
      this.id_usuario = item.id_usuario;
      this.id_rol = item.id_rol;
      this.nombre = item.nombre;
      this.correo = item.correo;
      this.contraseña = item.password_hash;
      this.act_contraseña = item.password_hash;
      this.activo = item.activo;

      this.listarUsuarioSucuarsales(item.id_empresa, item.id_usuario);

      this.dialog_usuario = true;
    },
    listarUsuarioSucuarsales(id_empresa, id_usuario) {
      axios
        .get(
          "api/Usuarios/ListarUsuariosSucursales/" +
            id_empresa +
            "/" +
            id_usuario
        )
        .then((response) => {
          //console.log(response.data);
          if (response.data.length > 0) {
            this.id_sucursal = response.data[0].id_sucursal;
            this.id_punto_venta = response.data[0].id_punto_venta;
          }
        });
    },
    actualizarUsuario() {
      var flag = false;

      if (this.contraseña != this.act_contraseña) {
        flag = true;
      }

      axios
        .put("api/Usuarios/Actualizar", {
          id_usuario: this.id_usuario,
          id_rol: this.id_rol,
          nombre: this.nombre,
          correo: this.correo,
          password: this.contraseña,
          act_password: flag,
          id_empresa: this.$store.state.emp.id_empresa,
          id_usuario: this.id_usuario,
          id_sucursal: this.id_sucursal,
          id_punto_venta: this.id_punto_venta,
          activo: this.activo
        })
        .then(() => {
          this.snackbar_text = "Usuario actualizado";
          this.snackbar = true;
          this.dialog_usuario = false;
          this.limpiarVariables();
          this.listarUsuariosPorEmpresa();
        })
        .catch(() => {
          this.snackbar_text = "Sucedio algún error";
          this.snackbar = true;
        });
    },
    cerrarDialogNuevoUsuario() {
      this.dialog_usuario = false;
      this.limpiarVariables();
    },
    limpiarVariables() {
      this.id_usuario = 0;
      this.id_rol = 0;
      this.nombre = "";
      this.correo = "";
      this.contraseña = "";
      this.act_contraseña = "";
      this.id_sucursal = 0;
      this.id_punto_venta = 0;
      this.activo = true;
      if (this.code != 0) {
        this.$refs.form.resetValidation();
      }
    },
    listarSucursales() {
      axios
        .get("api/sucursales/listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_sucursales = response.data;
        });
    },
    listarPuntosVenta() {
      axios
        .get("api/PuntoVentas/listar/" + this.$store.state.emp.id_empresa)
        .then((response) => {
          this.items_punto_venta = response.data;
        });
    },
    //EMPRESAS//////////////////////////////////////////////////////////
    aplicarCambios(id) {
      //console.log(id);
      Promise.all([this.guardarEmp(id), this.removerEmp()]).then(() => {
        this.snackbar_text = "Cambios aplicados";
        this.snackbar = true;
        this.limpiarVariables();
        this.listarUsuariosPorEmpresa();
        this.cancelarEmp();
      });
    },
    guardarEmp(id) {
      //console.log("select", this.select_emp);
      this.select_emp.forEach((element) => {
        if (!element.id_usuario) {
          axios.post("api/UsuariosXEmpresas/Crear", {
            id_usuario: id,
            id_empresa: element.id_empresa,
          });
        }
      });
    },
    removerEmp() {
      //console.log("unselect", this.unselect_emp);
      this.unselect_emp.forEach((element) => {
        axios.delete(
          "api/UsuariosXEmpresas/Eliminar/" +
            this.id_usuario +
            "/" +
            element.id_empresa
        );
      });
    },
    estatuSeleccionado(data) {
      //console.log(data);

      if (data.value) {
        //VERIFICAR EN unselect_emp Y REMOVER
        this.unselect_emp.splice(
          this.unselect_emp.findIndex((e) => e.cod_empresa == data.cod_empresa),
          1
        );
      } else {
        //AGREGAR EN unselect_emp
        this.unselect_emp.push(data.item);
      }
    },
    cancelarEmp() {
      this.select_emp = [];
      this.unselect_emp = [];
      this.dialog_empresas = false;
      this.limpiarVariables();
    },
  },
};
</script>